import {LEAGUES_GROUP_LINKS} from "../../config";

export const breadcrumbSchema = [
    {
        title: 'Leagues',
        path: LEAGUES_GROUP_LINKS.BASE
    },
    {
        title: 'Leagues details',
    }
];

export const ACTION_WAITING_LEAGUE = {
    DECLINE: 'decline',
    ACCEPT: 'accept'
};

export const popupSchema = {
    [ACTION_WAITING_LEAGUE.DECLINE]: {
        isDanger: true,
        title: 'Decline',
        body: 'Are you sure you want to decline this request?',
        labelDone: 'Yes, Decline',
    }
}

export const menuSchema = {
    [ACTION_WAITING_LEAGUE.DECLINE]: {
        color: 'danger',
        label: 'Decline',
        outline: true,
        popupSchema: popupSchema[ACTION_WAITING_LEAGUE.DECLINE],
    },
    [ACTION_WAITING_LEAGUE.ACCEPT]: {
        color: 'success',
        label: 'Accept',
        outline: false,
    },
};



